/*
 *
 * AssignedFormDialog14326
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';

import { ASSIGNED_REQUESTS_FORM, ASSIGNED_REQUESTS_FORM_DIALOG } from 'pages/Requests/AssignedView/constants';

export function AssignedFormDialog14326({ form }) {
  return (
    <AdvancedFormDialog
      name={ASSIGNED_REQUESTS_FORM_DIALOG}
      formName={ASSIGNED_REQUESTS_FORM}
      advancedForm={form}
      addModeTitle="Новая заявка"
      editModeTitle="Изменение заявки"
      viewModeTitle="Просмотр заявки"
      copyModeTitle="Копирование заявки"
      addModeSaveButtonLabel="Сохранить и Отправить"
      copyModeSaveButtonLabel="Сохранить и Отправить"
    />
  );
}

AssignedFormDialog14326.propTypes = {
  form: PropTypes.node.isRequired,
};
